module.exports = __webpack_public_path__ + "img/arrow-down.2d08bf14.svg";